import React, { PropsWithChildren } from "react";

import { AutofixMatchPanel } from "@components/AutofixMatchPanel";
import { CliMatch } from "@types";

interface Props {
  onResultClick?: (line?: number) => () => void;
  message?: string;
  line?: number;
}

export interface MatchProps extends Props {
  item: CliMatch;
  fixes?: string[];
  dirty: boolean;
  fixesApplied?: { [key: string]: boolean };
  onApplyFix?: (r: CliMatch) => () => void;
}

export const SingleResultPanel: React.FC<PropsWithChildren<Props>> = ({
  children,
  onResultClick,
  message,
  line,
}) => {
  return (
    <div
      className="result-container"
      onClick={onResultClick && onResultClick(line)}
    >
      <div className="result-details">
        <h6 className="bp3-heading">{line ? "Line " + line + ":" : ""}</h6>
        {message}
        {children}
      </div>
    </div>
  );
};

export const SingleMatchPanel: React.FC<MatchProps> = (props) => {
  return (
    <SingleResultPanel {...props}>
      <AutofixMatchPanel {...props} />
    </SingleResultPanel>
  );
};
